import React from 'react';
import cn from '@/utils/cn';
import Icon from '@/components/ui/Icon';

interface GenerationMetadata {
  generatedAt: string;
  generatedBy?: string;
  model?: string;
}

interface AILevelMetadataProps {
  badge: string;
  editedAt?: string;
  generatedAt?: string;
  metadata?: GenerationMetadata;
}

const AILevelMetadata = ({ badge, editedAt, generatedAt, metadata }: AILevelMetadataProps) => (
  <div className="tw-mb-4 tw-rounded tw-border tw-border-solid tw-border-[#ddd] tw-bg-[#f9f9fb] tw-p-3">
    <div className="tw-flex tw-items-center tw-gap-2 tw-mb-1">
      <span
        className={cn(
          'tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-0.5 tw-rounded-full',
          'tw-text-xs tw-font-semibold tw-text-white',
          'tw-bg-gradient-to-b tw-from-[#7954BA] tw-to-[#3F1587]',
        )}
      >
        <Icon fill="white" icon="Sparkle" size={8} />
        AI
      </span>
      <span className="tw-text-sm tw-font-semibold tw-text-gray-700">
        {badge}
      </span>
    </div>
    {metadata ? (
      <div className="tw-text-xs tw-text-gray-500 tw-flex tw-flex-wrap tw-gap-x-2">
        <span>Generated: {metadata.generatedAt}</span>
        {metadata.generatedBy && <span>· By: {metadata.generatedBy}</span>}
        {metadata.model && <span>· Model: {metadata.model}</span>}
        {editedAt && <span>· Last edited: {editedAt}</span>}
      </div>
    ) : (
      <span className="tw-text-xs tw-text-gray-500">
        Generated: {generatedAt}
      </span>
    )}
  </div>
);

export default AILevelMetadata;
